import s from "./ProgressBar.module.css";

type ProgressBarProps = {
  progress: number;
  description?: string;
};

const ProgressBar = ({ progress, description }: ProgressBarProps) => {
  return (
    <div className={s.progressBlock}>
      <span className={s.percents}>{progress}%</span>
      <div className={s.progressLineBlock}>
        <div style={{ width: `${progress}%` }} className={s.progressLine}></div>
      </div>
      <span className={s.description}>{description}</span>
    </div>
  );
};

export default ProgressBar;
